import { css } from '@emotion/react';

import { WarningDelta } from '@/Client/Icons';
import { formatUsd } from '@/Client/Presenters';
import { KAI_SHIKI_TYPOGRAPHY } from '@/Client/Styles/kaiShikiTokens';
import { COLORS } from '../CloseoutReviewFlow/closeoutTokens';

const SCAN_COST_DISPLAY_STYLE = css`
  label: SCAN_COST_DISPLAY_STYLE;
  ${KAI_SHIKI_TYPOGRAPHY.mediumBold}
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 100px;
  color: ${COLORS.ink};
  justify-content: flex-end;
`;

const DELTA_COST_STYLE = css`
  label: DELTA_COST_STYLE;
  color: ${COLORS.textSecondary};
  padding-bottom: 4px;
  border-bottom: 1px solid ${COLORS.textTertiary};
`;

const BASELINE_COST_STYLE = css`
  label: BASELINE_COST_STYLE;
  color: ${COLORS.textTertiary};
  text-decoration: line-through;
`;

const COST_DISPLAY_STYLE = css`
  label: COST_DISPLAY_STYLE;
  display: flex;
  padding-top: 3px;
  align-items: center;
  gap: 2.5px;
`;

const COST_INCREASE_STYLE = css`
  label: COST_INCREASE_STYLE;
  color: ${COLORS.error};
`;

const COST_DECREASE_STYLE = css`
  label: COST_DECREASE_STYLE;
  color: ${COLORS.ink};
`;

const TINY_LABEL_STYLE = css`
  label: TINY_LABEL_STYLE;
  ${KAI_SHIKI_TYPOGRAPHY.tiny}
  color: ${COLORS.textTertiary};
  text-align: right;
`;

export const ScanCostDisplayWithDeltaSupportNew = ({
  cost,
  baselineCost,
  showBaseline,
}: {
  cost?: number;
  baselineCost?: number;
  showBaseline: boolean;
}) => {
  const deltaCost = (cost ?? 0) - (baselineCost ?? 0);
  const changed = Math.abs(deltaCost) > 0.005;

  if (!showBaseline || !changed) {
    return (
      <div css={SCAN_COST_DISPLAY_STYLE}>
        {formatUsd(cost)}
      </div>
    );
  }
  const wasIncreased = deltaCost > 0.005;

  return (
    <div css={SCAN_COST_DISPLAY_STYLE}>
      <div css={BASELINE_COST_STYLE}>
        {formatUsd(baselineCost, false, true)}
      </div>
      <div css={TINY_LABEL_STYLE}>(original)</div>
      <div css={[DELTA_COST_STYLE]}>
        {deltaCost > 0 ? '+' : '-'}
        {formatUsd(Math.abs(deltaCost), false, true)}
        <div css={TINY_LABEL_STYLE}>(difference)</div>
      </div>
      <div css={[COST_DISPLAY_STYLE, wasIncreased ? COST_INCREASE_STYLE : COST_DECREASE_STYLE]}>
        <WarningDelta />
        {formatUsd(cost)}
      </div>
      <div css={TINY_LABEL_STYLE}>(new price)</div>
    </div>
  );
};
